import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';

export const FinancialPolicyItemsStyled = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
    gap: 32px;
    .image {
        display: flex;
        align-items: center;
        height: 90px;
    }
    .visa {
        display: flex;
        align-items: center;
        width: 170px;
        div {
            height: 128px;
        }
    }
    @media ${({ theme }) => theme.device.tablet} {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        .visa {
            display: flex;
            align-items: center;
            width: 480px;
            div {
                height: 128px;
            }
        }
    }
`;

export const FinancialPolicyItems: React.FC = () => {
    return (
        <FinancialPolicyItemsStyled className="container">
            <div className="visa">
                <StaticImage
                    objectFit="contain"
                    src="../images/11-financial-policy/visa.png"
                    quality={80}
                    alt="visa"
                />
            </div>
            <div className="image">
                <StaticImage
                    objectFit="contain"
                    style={{ height: '100%' }}
                    src="../images/11-financial-policy/mastercard.png"
                    quality={80}
                    alt="mastercard"
                />
            </div>
            <div className="image">
                <StaticImage
                    objectFit="contain"
                    style={{ height: '100%' }}
                    src="../images/11-financial-policy/discover.png"
                    quality={80}
                    alt="discover"
                />
            </div>
            <div className="image">
                <StaticImage
                    objectFit="contain"
                    style={{ height: '100%' }}
                    src="../images/11-financial-policy/american-express.png"
                    quality={80}
                    alt="american express"
                />
            </div>
        </FinancialPolicyItemsStyled>
    );
};
